import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6979f88f921dc90014dd2890/caliberstore/src/app/product-catalog/components/ProductCatalogInteractive.tsx");
